import type { SVGProps } from 'react';
const SvgArrowSmallDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <path
      d="M12 6 8.188 9.92A.27.27 0 0 1 8 10a.26.26 0 0 1-.188-.08L4 6"
      strokeLinejoin="round"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
    />
  </svg>
);
export default SvgArrowSmallDown;
